import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from 'src/services/auth/auth.service';

export const authGuard: CanActivateFn = async (): Promise<boolean | UrlTree> => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const { data } = await authService.getSession();

  if (data.session == null) {
    return router.createUrlTree(['/login']);
  }

  if (!authService.isOperator(data.session)) {
    await authService.signOut();
    return router.createUrlTree(['/login'], { queryParams: { error: 'role' } });
  }

  return true;
};
